import {BaseService} from "./base.service";

class ClientsService extends BaseService {

    constructor() {
        super('api/clients')
    }

    getSkuClient(sku) {
        return this.http.get(`api/get-sku-client/0/${sku}`).then(response => response.data).catch(err => err.message);
    }

    getCardClient(card) {
        return this.http.get(`api/imprimir-tarjeta/${card}`).then(response => response.data).catch(err => err.message);
    }

    trashedClients(params) {
        return this.http.post(`api/trashed-clients`, {params}).then(response => response.data).catch(err => err.message);
    }

    restoreClient(id) {
        return this.http.get(`api/restore-client/${id}`).then(response => response.data).catch(err => err.message);
    }

    getClientAsCompany() {
        return this.http.get(`api/get-client-as-company`).then(response => response.data).catch(err => err.message);
    }

    getPaymentsClient(id) {
        return this.http.get(`api/get-payments-client/${id}`).then(response => response.data).catch(err => err.message);
    }

}

export const clientsService = new ClientsService();
